import {register} from '@shopify/theme-sections';

import renderProductCard from '../components/product-card-template';
import {initWishlistCallback} from '../utils/wishlist';
import {constructLocalisedProductLink} from '../utils/tagalys';

const selectors = {
  widget: '[data-widget="recommendations"]',
};

export default register('recommended-collection', {
  onLoad() {
    const container = this.container;

    const tagalysContainer = container.querySelector(selectors.widget);
    if (!tagalysContainer) {
      return;
    }

    initWishlistCallback(selectors.widget);

    const blockId = tagalysContainer.getAttribute('data-block-id') ?? '';
    const widgetId = tagalysContainer.getAttribute('data-recommendations-widget-id') ?? '';

    window.Tagalys?.UIWidgets.SmartWidget.init(`[data-block-id='${blockId}']`, {
      widgetId: widgetId,
      templates: {
        widget: {
          options: {
            limit: 8,
            displayFormat: 'carousel',
            includeTagalysCSS: false,
            carouselOptions: {
              perPage: {
                300: 2,
                768: 3,
                1280: 4,
              },
            },
          },

          render: function (html, args) {
            const {props} = args;
            const {helpers} = props;
            const products = helpers.getProducts();

            if (props.loading === false) {
              if (products.length === 0) {
                return null;
              }
              return html`
                <div class="product-recommendations">
                  <${args.templates.productList} />
                </div>
              `;
            }
          },
        },
        products: {
          render: function (html, args) {
            const {props} = args;
            const products = props.helpers.getProducts();

            return html`
              <div class="products products-carousel">
                ${products.map((product, index) => {
                  return html` <${args.templates.product} key=${index} product=${product} /> `;
                })}
              </div>
            `;
          },
          callbacks: {
            afterInitialRender: function () {
              // Wishlist Plus (Swym) - custom event dispatched to initialise button for new products loaded
              document.dispatchEvent(new CustomEvent('swym:products-loaded'));
            },
            afterEveryRender: function () {
              document.dispatchEvent(new CustomEvent('results-grid:loaded'));
            },
          },
        },
        product: {
          options: {
            // Generate the product page URL using the product object
            productPageUrl(product) {
              return constructLocalisedProductLink(product);
            },
          },
          render: function (html, args) {
            const {props} = args;
            const {product, helpers} = props;

            return html`<div dangerouslySetInnerHTML=${{__html: renderProductCard(product, helpers)}} />`;
          },
        },
        carouselActions: {
          render: function (html, args) {
            const {props} = args;

            return html`
              <button
                class="products-carousel__btn products-carousel__prev"
                disabled=${props.helpers.carousel.isFirstSlide()}
                onClick=${props.helpers.carousel.goLeft}
              >
                <svg
                  aria-label="Chevron left icon"
                  class="icon icon-chevron-left"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m14 18-6-6 6-6"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </button>

              <button
                class="products-carousel__btn products-carousel__next"
                disabled=${props.helpers.carousel.isLastSlide()}
                onClick=${props.helpers.carousel.goRight}
              >
                <svg
                  aria-label="Chevron right icon"
                  class="icon icon-chevron-right"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m10 18 6-6-6-6"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </button>
            `;
          },
        },
      },
    });
  },
});
